module.exports = __webpack_public_path__ + "img/pic_Ecua_Quito.6d31d86e.jpg";